import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Icon, withStyles, BodyText } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import styles from './EnhancedVerificationCardDialog.module.scss';
import Feature from '../Feature';
import { useTranslation } from 'react-i18next';

type EnhancedVerificationCardDialogProps = {
  onCancel: () => void;
};

const cn = withStyles(styles);

const EnhancedVerificationCardDialog: FC<EnhancedVerificationCardDialogProps> = ({ onCancel }) => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'InteracVerification.EnhancedVerificationCardDialog' });

  return (
    <Card className={cn('enhancedVerificationCardDialog')}>
      <Title level="3">{t('title', { defaultValue: 'Enhanced Verification' })}</Title>

      <div className={cn('closeButton')}>
        <CircleButton icon="close" size="large" circleFill onClick={onCancel} />
      </div>

      <BodyText className={cn('description')}>
        {t('desc', {
          defaultValue:
            'Confirm ownership and registration details retrieved from card processor records for this contact.',
        })}
      </BodyText>

      <div className={cn('features')}>
        <Feature
          icon={<Icon icon="badgeBlueGradient" width="35px" height="35px" color="none" />}
          title={t('CardHolderName.title', { defaultValue: 'Card Holder Name' })}
          desc={t('CardHolderName.desc', {
            defaultValue: 'See the registered name tied to the card.',
          })}
        />

        <Feature
          icon={<Icon icon="cardBlueGradient" width="35px" height="35px" color="none" />}
          title={t('CardAndCardBrand.title', { defaultValue: 'Card & Card brand' })}
          desc={t('CardAndCardBrand.desc', { defaultValue: 'Identify if the card is personal, business, or prepaid.' })}
        />

        <Feature
          icon={<Icon icon="currencyExchangeBlueGradient" width="35px" height="35px" color="none" />}
          title={t('EligibilityToSendReceive.title', { defaultValue: 'Eligibility to send & receive funds' })}
          desc={t('EligibilityToSendReceive.desc', {
            defaultValue: 'Verify if the account accepts & processes fund transfers.',
          })}
        />

        <Feature
          icon={<Icon icon="accessTimeBlueGradient" width="35px" height="35px" color="none" />}
          title={t('EstimatedFundAvailability.title', { defaultValue: 'Estimated fund availability' })}
          desc={t('EstimatedFundAvailability.desc', {
            defaultValue: 'Get an estimated time for when the transferred funds will be available',
          })}
        />
      </div>

      <Button
        className={cn('button')}
        colorScheme="primary"
        onClick={() => {
          onCancel();

          history.push({
            pathname: '/create-tickets',
            state: { ticketSubject: t('ticketSubject', { defaultValue: 'Enquiry about Enhanced Card verification' }) },
          });
        }}
      >
        {t('contactButton', { defaultValue: 'Contact Support' })}
      </Button>
    </Card>
  );
};

export default EnhancedVerificationCardDialog;
